module.exports = __webpack_public_path__ + "static/media/54.f743a2bb.jpg";